import { render, staticRenderFns } from "./10001.vue?vue&type=template&id=32ab4b79&scoped=true&"
import script from "./10001.vue?vue&type=script&lang=js&"
export * from "./10001.vue?vue&type=script&lang=js&"
import style0 from "./10001.vue?vue&type=style&index=0&id=32ab4b79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ab4b79",
  null
  
)

export default component.exports